import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import './Legal.sass'

const Legal = () => {
  return (
    <div id="legal" className="page split">
      <header className="item left" id="legal-header" />
      <section className="item right" id="legal-content">
        <div className="wrapper">
          <img src="images/logo.png" alt="logo" />
          <Link to="/register">
            <span className="icon icon-arrow-left" />
            <FormattedMessage id="recover.back" />
          </Link>
          <h1>1.Información y datos suministrados por el usuario</h1>
          <p>
            Toda la información y datos que sean comunicados por el usuario
            mediante el registro en Security Hub, serán tratados por SECURITAS
            SEGURIDAD ESPAÑA, S.A. con el fin de poder gestionar adecuadamente
            su solicitud de acceso a la aplicación Security Hub, así como
            remitirle su usuario y claves de acceso a la misma. A tal efecto, el
            tratamiento y uso de los datos e informaciones derivadosde este
            canal de comunicación se llevará a cabo por SECURITAS de acuerdo
            conlos términos y obligaciones asumidos por esta entidad en el marco
            del Contrato de Encargo del Tratamiento que, conforme al artículo 28
            del Reglamento (UE) 2016/679, General de Protección de Datos (RGPD).{' '}
          </p>
          <h1>
            2.Información sobre el tratamiento por SECURITAS de datos de
            carácter personal del usuario
          </h1>
          <p>
            De conformidad con el Reglamento (UE) 2016/679, General de
            Protección de Datos, SECURITAS informa al usuario de los siguientes
            extremos:
          </p>
          <p>
            2.1. Responsable del tratamiento SECURITAS SEGURIDAD ESPAÑA, S.A.,
            con domicilio en C/ Entrepeñas 27, 28051 Madrid, teléfono de
            contacto 91 277 60 00 y dirección electrónica de contacto{' '}
            <a href="mailto:info@securitas.es">info@securitas.es</a>.
          </p>
          <p>
            2.2. Delegado de Protección de Datos El usuario puede contactar con
            el Delegado de Protección de Datos de Securitas en la dirección de
            contacto{' '}
            <a href="mailto:sandra.depablo@securitas.es">
              sandra.depablo@securitas.es
            </a>
            .
          </p>
          <p>
            2.3. Finalidades y bases jurídicas del tratamiento de datos
            personales del usuario SECURITAS tratará los datos suministrados por
            el usuario para la asignación de usuario y contraseña de la App con
            los siguientes fines y bases jurídicas legitimadoras del
            tratamiento: - Con base jurídica en consentimiento del interesado,
            SECURITAS tratará los datos del usuario con la finalidad de
            facilitar los datos de alta de usuario en la App y de posibilitar al
            usuario la utilización de los servicios de comunicación directa de
            SECURITAS
          </p>
          <p>
            2.4. Destinatarios de los datos Los datos personales del usuario
            serán comunicados a terceros en caso de que exista una obligación
            legal de comunicación a las autoridades públicas competentes por
            razón de la materia y/o para la atención de los requerimientos
            realizados por estas. En tales casos, SECURITAS llevará a cabo
            cesiones o comunicaciones de datos a los jueces y tribunales,
            Ministerio Fiscal, Fuerzas y Cuerpos de Seguridad, autoridades y
            administraciones públicas competentes cuando así se requiera de
            acuerdo con la Legislación vigente en cada momento. Además, otras
            empresas que prestan servicios auxiliares a SECURITAS como servicios
            de alojamiento de información, servicios informáticos, servicios de
            mantenimiento y otros, tendrán acceso a losdatos personales del
            usuario al amparo de un contrato de prestación de servicios y otro
            de encargo de tratamiento con la obligación de devolución y/o
            destrucción de los datos a la finalización del servicio.{' '}
          </p>
          <p>
            2.5. Necesidad del tratamiento El suministro y comunicación de los
            datos personales del usuario constituye un requisito necesario para
            realizar el alta del usuario en la App, quedando informado el
            usuario de que la consecuencia de no facilitar sus datos puede ser
            la imposibilidad de su prestación.{' '}
          </p>
          <p>
            2.6. Plazo de conservación de datosLos datos personales del usuario
            se conservarán durante los plazos establecidosen las normas
            aplicables para el cumplimiento de obligaciones legales y la
            atención de posibles responsabilidades.
          </p>
          <p>2.7. Transferencias internacionales de datos No se realizan.</p>
          <p>
            2.8. Derechos El usuario puede ejercitar sus derechos de acceso,
            rectificación, supresión y oposición, limitación del tratamiento y
            portabilidad de sus datos personales, mediante el envío a SECURITAS
            de una solicitud a la siguiente dirección postal C/ Entrepeñas 27,
            28051 Madrid, o electrónica{' '}
            <a href="mailto:info@securitas.es">info@securitas.es</a>, indicando
            el derecho que ejercita y aportando una fotocopia por las dos caras
            de su DNI/NIF o documento legal que acredite su identidad.
          </p>
          <p>
            2.9. Reclamación ante la autoridad de control En cualquier caso,
            elusuario queda informado del derecho que le asiste a presentar una
            reclamaciónante una autoridad de control, en España la Agencia
            Española de Protección de Datos, a través de{' '}
            <a target="_blank" href="http://www.aepd.es" rel="noreferrer">
              www.aepd.es
            </a>{' '}
            o en la siguiente dirección C/ Jorge Juan, 6. 28001 – Madrid, y/o
            teléfono de contacto 912 663 517, en particular, cuando considere
            que no ha obtenido satisfacción por parte de SECURITAS en el
            ejercicio de sus derechos. Con carácter previo y voluntario a la
            interposición de la reclamación ante la AEPD, podrá contactar con el
            delegado de protección de datos del responsable del tratamiento en
            la dirección de contacto indicada.
          </p>
          <h1>3.Gestión de usuarios de Security Hub</h1>
          <p>
            El usuario principal el cual solicita el alta mediante el registro
            en Security Hub, es responsable de la jerarquía de usuarios que
            pueda generar, delegar o solicitar a SECURITAS así como de los
            permisos creados, delegados o solicitados para cada uno de los
            usuarios en las distintas secciones de Security Hub.
          </p>
        </div>
      </section>
    </div>
  )
}

export default Legal
